import SelectedServiceCard from 'components/BookingTable/SelectedServiceCard';
import { isEmpty } from 'lodash';
import React, { useState, useEffect, useRef } from 'react'
import { Search, Icon } from 'semantic-ui-react';
import { getServiceList as _getServiceList, getTopPageServices } from '../../services/Services';
import './SearchServiceControl.less'

const debouncePeriod = 600;
const minCharacters = 1;
function SearchServiceControl(props) {

    let debouncedSearchFn;
    const [serviceSearchLoading, setServiceSearchLoading] = useState(false);


    const [results, setResults] = useState([]);
    const [selectedValue, setSelectedValue] = useState({});
    const [selectedServiceID, setSelectedServiceID] = useState(0);

    const [searchPhrase, setSearchPhrase] = useState('');

    const timeoutRef = React.useRef()

    const searchRef = useRef();

    useEffect(() => {

        clearTimeout(timeoutRef.current);

        timeoutRef.current = setTimeout(() => {

            if (!isEmpty(searchPhrase) && searchPhrase.length >= minCharacters) {
                getServiceList();

            }
            setServiceSearchLoading(false);
        }, debouncePeriod);

    }, [searchPhrase]);

    React.useEffect(() => {
        searchRef.current.focus();
        return () => {
            clearTimeout(timeoutRef.current)
        }
    }, []);

    const handleSearchChange = (e, data) => {
        setServiceSearchLoading(true);
        setSearchPhrase(data.value);
        setSelectedServiceID(0);
        setSelectedValue({});
        if (props.setSelectedService)
            props.setSelectedService({});

    }

    const handleResultSelect = (e, data) => {
        setSearchPhrase(data.result.title);
        setSelectedServiceID(data.result.id);
        if (props.setSelectedService && !isEmpty(data.result))
            props.setSelectedService(data.result);
    }

    const onSearchSelectionChange = (e, data) => {
        if (!data) return;
        setSelectedValue(data.result);
    }

    const getServiceList = () => {

        let services = [];
        const phrase = searchPhrase;

        _getServiceList(phrase)
            .then((res) => {
                let data = res.data;
                if (data && data.length > 0) {
                    if (props.skipServiceID) {
                        data = _.filter(data, (service) => {
                            return service.serviceID != props.skipServiceID;
                        })
                    }

                    if (props.categoryid) {
                        data = _.filter(data, (service) => {
                            return service.categoryID == props.categoryid;
                        })
                    }
                    data.map((a) => {

                        let service = { id: a.serviceID, title: a.name, categoryID: a.categoryID };
                        services.push(service);

                    });

                    setServiceSearchLoading(false);
                    setResults(services);
                    setSelectedValue(services[0] || {});


                }
                else {
                    setServiceSearchLoading(false);
                    setResults([]);
                }



            })
            .catch(() => {
                //this.props.showNotificationMessage(ERROR, 'Service pin toggle failed.');
            });
    };

    const handleServiceReset = () => {
        setSearchPhrase('');
        setSelectedServiceID(0);
        setSelectedValue({});
        if (props.setSelectedService)
            props.setSelectedService({});
    }

    return (
        <div className="service-search-control-container">
        <Search
            input={{ ref: searchRef }}
            className="service-search-control"
            loading={serviceSearchLoading}
            value={searchPhrase}
            onSearchChange={handleSearchChange}
            results={results}
            onResultSelect={handleResultSelect}
            placeholder='Search service'
            minCharacters={minCharacters}
            //onFocus={this.getTopPageServiceList}
            onSelectionChange={onSearchSelectionChange}
            selectFirstResult={true}
            //onBlur={(e) => handleResultSelect(e, { result: selectedValue })}

        />
        {selectedServiceID > 0 && <Icon onClick={handleServiceReset} className='search-control-reset-btn' name='close' />}
        </div>
    )
}

export default SearchServiceControl
